/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-props-no-spreading */
import React from "react";

import { IconButton, useMediaQuery } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { useTheme } from "@mui/material/styles";
import { TransitionProps } from "@mui/material/transitions";
import { XIcon } from "components";
import { DialogFieldName, useDialog } from "stores/Dialog";
import { i18n } from "translations";
import { rem } from "utils";

import LoadingOverlay from "../molecules/LoadingOverlay";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface CommonDialogProps {
  name: DialogFieldName;
  open?: boolean;
  width?: number;
  onToggle?: () => void;
  title?: string;
  titleI18n?: string;
  dialogProps?: Partial<React.ComponentProps<typeof Dialog>>;
  hideCloseButton?: boolean;
  action?: React.ReactNode;
  children?: React.ReactNode;
  loading?: boolean;
}

const CommonDialog: React.FC<CommonDialogProps> = ({
  name,
  open,
  width,
  title,
  titleI18n,
  dialogProps,
  hideCloseButton = false,
  action,
  children,
  loading,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(820));
  const {
    dialog: { show },
    onToggle,
  } = useDialog({ name });

  const handleClose = (_event: any, reason: string) => {
    if (reason && reason === "backdropClick") return;
    onToggle();
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      TransitionComponent={Transition}
      scroll="body"
      open={open || show}
      onClose={handleClose}
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          overflowY: "visible !important",
          height: "fit-content !important",
        },
      }}
      sx={{
        ...(width && {
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: `${width}px`,
            },
          },
        }),
      }}
      {...dialogProps}
    >
      <DialogTitle sx={{ paddingBottom: 0 }}>
        {titleI18n ? i18n.t(titleI18n) : title}
      </DialogTitle>
      {!hideCloseButton && (
        <IconButton
          aria-label="close"
          onClick={onToggle}
          sx={{
            position: "absolute",
            right: 15,
            top: 15,
          }}
        >
          <XIcon />
        </IconButton>
      )}

      <DialogContent sx={{ overflow: "visible !important" }}>
        <LoadingOverlay loading={loading}>{children}</LoadingOverlay>
      </DialogContent>
      {action && (
        <DialogActions sx={{ padding: `${rem(16)} ${rem(24)}`, paddingTop: 0 }}>
          {action}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default CommonDialog;
